import { Component, computed, inject, Signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  SelectedWorkspaceService,
  WorkspacesCrudService,
} from '@tokenbox/services';
import { RouterLink } from '@angular/router';
import { MenuItem, PrimeIcons } from 'primeng/api';
import { ButtonDirective, ButtonIcon, ButtonLabel } from 'primeng/button';
import { Menu } from 'primeng/menu';

@Component({
  selector: 'dt-workspace-selector',
  imports: [
    ReactiveFormsModule,
    RouterLink,
    FormsModule,
    ButtonDirective,
    ButtonIcon,
    ButtonLabel,
    Menu,
  ],
  templateUrl: './workspace-selector.component.html',
  styleUrl: './workspace-selector.component.scss',
})
export class WorkspaceSelectorComponent {
  protected readonly PrimeIcons = PrimeIcons;
  private workspacesCrudService = inject(WorkspacesCrudService);
  private selectedWorkspaceService = inject(SelectedWorkspaceService);

  allWorkspacesByTeam: Signal<MenuItem[]> = computed(() => {
    const allWorkspacesByTeam =
      this.workspacesCrudService.allWorkspacesByTeam();
    return allWorkspacesByTeam.map(
      (team) =>
        ({
          label: team.name,
          items: team.workspaces.map(
            (workspace) =>
              ({
                label: workspace.name,
                icon: this.selectedWorkspaceService.isSelected(workspace)
                  ? PrimeIcons.CHECK_CIRCLE
                  : PrimeIcons.CIRCLE,
                styleClass: this.selectedWorkspaceService.isSelected(workspace)
                  ? 'font-semibold'
                  : undefined,
                routerLink: `/workspaces/${workspace.id}`,
              }) satisfies MenuItem,
          ),
        }) satisfies MenuItem,
    );
  });
  selectedWorkspace = this.selectedWorkspaceService.selectedWorkspace;
}
